import { WhmButton, WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import { Translate } from "../../../../../Translation/Translate";
import { translationKeys } from "../../../../../../contexts/I18nContext";
import { ReactComponent as InProgressEmpty } from "./InProgressEmpty.svg";
import { Link } from "react-router-dom";

export default function InProgressEmptyState() {
  return (
    <WhmStack padding="24px" gap="16px" alignItems="center" textAlign="center">
      <InProgressEmpty />
      <WhmTypography variant="h4">
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_IN_PROGRESS_EMPTY_STATE_TITLE
          }
        />
      </WhmTypography>
      <WhmTypography variant="body1">
        <Translate
          translationKey={
            translationKeys.PORTFOLIO_IN_PROGRESS_EMPTY_STATE_DESCRIPTION
          }
        />
      </WhmTypography>
      <WhmButton
        variant="contained"
        component={Link}
        // @ts-expect-error ignore
        to="/primary-market"
        sx={{
          "&:hover": { color: "white" },
          width: { xs: "100%", xl: "fit-content" },
        }}
      >
        <Translate
          translationKey={translationKeys.PORTFOLIO_IN_PROGRESS_EMPTY_STATE_CTA}
        />
      </WhmButton>
    </WhmStack>
  );
}
